import type { Timestamp } from 'firebase/firestore';

export type TierId = 'garage' | 'restorer' | 'pro_shop';

export type SubscriptionStatus =
  | 'active'
  | 'trialing'
  | 'past_due'
  | 'canceled'
  | 'unpaid'
  | 'incomplete'
  | 'incomplete_expired'
  | 'paused';

export interface Subscription {
  tier: TierId | null;
  status: SubscriptionStatus;
  priceId: string | null;
  stripeSubscriptionId: string;
  currentPeriodEnd: Timestamp;
  cancelAtPeriodEnd: boolean;
}

export function isActiveSubscription(sub: Subscription | undefined | null): boolean {
  if (!sub) return false;
  return sub.status === 'active' || sub.status === 'trialing';
}
